import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

/**
 * HomeSearchBar
 *
 * Kept search entry point (navigates to /search). Visual-only field.
 */
export default function HomeSearchBar() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate("/search")}
      className="flex items-center gap-[10px] mx-4 mb-4 bg-white border border-wc-border rounded-lg px-[15px] py-[13px] cursor-pointer lg:mx-0 lg:mb-0 lg:order-2 lg:flex-1 lg:basis-1/2 lg:py-[17px]"
    >
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-[19px] h-[19px] text-ink-500 flex-none"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <span className="text-[14px] text-ink-400 font-[400]">
        {t("search.placeholder")}
      </span>
    </div>
  );
}
